/* eslint-disable no-nested-ternary */
import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import uniqueId from 'lodash/uniqueId';
import { Auth } from '@aws-amplify/auth';
import FormSpinner from '../../common/utility/FormSpinner';
import * as upgradeAccountActions from '../../../store/actions/upgrade-account-actions';
import { hasValue, isNullOrUndefined, toggleCssClass } from '../../../../../general/js/general-helpers';
import { MembershipTypes, getDestructuredTextWithMultipleLinks, getMultilineText } from '../../../../../general/js/utils';

function SignInSuccessForm({
    actions,
    formData,
    loading,
}) {
    const [agreedPrivacyPolicy, setAgreePrivacyPolicy] = useState(false);
    const [displayForm, setDisplayForm] = useState(false);
    const [agreedTermsAndConditions, setAgreeTermsAndConditions] = useState(false);
    const [isOneClubMember, setIsOneClubMember] = useState(false);

    toggleModalCloseButton(formData);

    useEffect(() => {
        Auth.currentAuthenticatedUser().then((user) => {
            setIsOneClubMember(user.attributes['custom:Membership'].includes(MembershipTypes.OneClub));
            setAgreePrivacyPolicy(JSON.parse(user.attributes['custom:OptIns']).agreedToPrivacyPolicy);
            setAgreeTermsAndConditions(JSON.parse(user.attributes['custom:OptIns']).agreedToTermsAndConditions);
            setDisplayForm(true);
        }).catch((err) => { console.log(err); });
    });

    return (
        <div className='form-popup' >
            {loading || !displayForm ? <FormSpinner>/</FormSpinner> : null}
            <section className='form-popup__content'>
                {displayForm ? <Fragment>
                    {
                        isOneClubMember && !agreedTermsAndConditions ?
                            <PrivacyPolicyAndTermsAndConditionsMessage formData={formData} actions={actions} /> :
                            !agreedPrivacyPolicy &&
                            <PrivacyPolicyMessage formData={formData} actions={actions} />
                    }
                </Fragment> : null}
            </section>
        </div>
    );
}

function toggleModalCloseButton(formData = {}, displayButton = false) {
    const { hideCloseButton } = hasValue(formData) ? (displayButton === true ? { hideCloseButton: false } : formData) : { hideCloseButton: false };

    const closeButton = document.querySelector('.modal__close');

    if (!isNullOrUndefined(closeButton)) {
        toggleCssClass(closeButton, 'is-hidden', hideCloseButton);
    }
}

function MultiLineMessage({ messageParagraphs, show }) {
    return (<div className='pop-up-message' style={{ display: show ? '' : 'none' }}>
        {
            messageParagraphs.map((message) => {
                return <Fragment key={uniqueId()}><p>{message}</p><br /></Fragment>;
            })
        }
    </div>);
}

function PrivacyPolicyMessage(props) {
    const { formData, actions } = props;

    const [hideSaveButton, setHideSaveButton] = useState(true);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);

    const { privacyAndPolicy, successMessage, privacyPolicyMessage } = formData;

    const messageParagraphs = getMultilineText(privacyPolicyMessage);
    const successMessageParagraphs = getMultilineText(successMessage);

    const updatePrivacyPolicy = (event) => {
        event.preventDefault();

        actions.agreeToPrivacyPolicyAndTermsAndConditions(formData.callbackUrl, true, null).then(() => {
            toggleModalCloseButton(formData, true);
            setShowSuccessMessage(true);
        });
    };

    const onAgreePrivacyPolicy = (event) => {
        setHideSaveButton(!event.target.checked);
    };

    return (<Fragment>
        {
            messageParagraphs.length > 0 ?
                <MultiLineMessage show={!showSuccessMessage} messageParagraphs={messageParagraphs}></MultiLineMessage> :
                null
        }
        <div
            className={'form-field auto-mt-xs joinOneClubCheck-field'} style={{ display: showSuccessMessage ? 'none' : '' }}>
            <h5 className='form-checkbox-panel__title'>
                {getDestructuredTextWithMultipleLinks(
                    privacyAndPolicy.policy.label,
                    privacyAndPolicy.policy.link.split(';')
                )}
            </h5>
            <label className="form-switch">
                <input
                    type='checkbox'
                    className='form-checkbox__checkbox visually-hidden'
                    name={'joinOneClubCheck'}
                    id={'joinOneClubCheck'}
                    defaultChecked={false}
                    onChange={onAgreePrivacyPolicy}
                /><i></i>{formData.privacyPolicyConsentText}
            </label>
        </div>
        <div className='form__sign-in'
            style={{ display: hideSaveButton || showSuccessMessage ? 'none' : 'flex' }} >
            <button
                className='button button--primary auto-mt-md'
                type='submit'
                data-dc-form-sso-ref='submit-button'
                onClick={updatePrivacyPolicy}
            >
                <span className='button-content button-content--icon'>
                    <span>{formData.updateButtonText}</span>
                    <svg
                        className='icon button__arrow-right'
                        width='14'
                        height='12'
                        focusable='false'
                    >
                        <use xlinkHref='#icon-arrow-right'></use>
                    </svg>
                </span>
            </button>
        </div>
        <MultiLineMessage show={showSuccessMessage} messageParagraphs={successMessageParagraphs}></MultiLineMessage>
    </Fragment >);
}

function PrivacyPolicyAndTermsAndConditionsMessage(props) {
    const { formData, actions } = props;

    const [hideSaveButton, setHideSaveButton] = useState(true);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);

    const { privacyPolicyAndTermsAndConditions, privacyAndTermsMessage, successMessage } = formData;

    const messageParagraphs = getMultilineText(privacyAndTermsMessage);
    const successMessageParagraphs = getMultilineText(successMessage);

    const agreeTermsAndPrivacy = (event) => {
        event.preventDefault();

        actions.agreeToPrivacyPolicyAndTermsAndConditions(formData.callbackUrl, true, true).then(() => {
            toggleModalCloseButton(formData, true);
            setShowSuccessMessage(true);
        });
    };

    const onAgreeTermsAndPrivacy = (event) => {
        setHideSaveButton(!event.target.checked);
    };

    return (<Fragment>
        {
            messageParagraphs.length > 0 ?
                <MultiLineMessage show={!showSuccessMessage} messageParagraphs={messageParagraphs}></MultiLineMessage> :
                null
        }
        <div
            className={'form-field auto-mt-xs joinOneClubCheck-field'} style={{ display: showSuccessMessage ? 'none' : '' }}>
            <h5 className='form-checkbox-panel__title'>
                {getDestructuredTextWithMultipleLinks(
                    privacyPolicyAndTermsAndConditions.policy.label,
                    privacyPolicyAndTermsAndConditions.policy.link.split(';')
                )}
            </h5>
            <label className="form-switch">
                <input
                    type='checkbox'
                    className='form-checkbox__checkbox visually-hidden'
                    name={'joinOneClubCheck'}
                    id={'joinOneClubCheck'}
                    defaultChecked={false}
                    onChange={onAgreeTermsAndPrivacy}
                /><i></i>{privacyPolicyAndTermsAndConditions.label}
            </label>
        </div>
        <div className='form__sign-in'
            style={{ display: hideSaveButton || showSuccessMessage ? 'none' : 'flex' }} >
            <button
                className='button button--primary auto-mt-md'
                type='submit'
                data-dc-form-sso-ref='submit-button'
                onClick={agreeTermsAndPrivacy}
            >
                <span className='button-content button-content--icon'>
                    <span>{formData.updateButtonText}</span>
                    <svg
                        className='icon button__arrow-right'
                        width='14'
                        height='12'
                        focusable='false'
                    >
                        <use xlinkHref='#icon-arrow-right'></use>
                    </svg>
                </span>
            </button>
        </div>
        <MultiLineMessage show={showSuccessMessage} messageParagraphs={successMessageParagraphs}></MultiLineMessage>
    </Fragment >);
}

function mapStateToProps(state, ownProps) {
    return {
        loading: state.apiStatus.apiCallsInProgress > 0,
        formData: hasValue(ownProps.formData) ? ownProps.formData : state.signInForm.signInSuccessFormData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            agreeToPrivacyPolicyAndTermsAndConditions: bindActionCreators(upgradeAccountActions.agreePrivacyPolicyAndTermsAndCoditions, dispatch)
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SignInSuccessForm);
